/**
 * Takes a string containing coordinates separated by a comma and returns an
 * object with parsed latitude and longitude, or `null` if the string is
 * incorrectly formatted.
 */
export const parseCoordinates = (
  coordinates: string,
): { latitude: number; longitude: number } | null => {
  const [latitude, longitude] = coordinates
    .split(',')
    .map(coord => parseFloat(coord.trim().replace(/[()]/g, '')));

  return Number.isNaN(latitude) || Number.isNaN(longitude)
    ? null
    : { latitude, longitude };
};
